import { useState } from 'react';
import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import { StartTrialModal } from '.'
import Lazyload from 'react-lazy-load'
const FitnessRewards = (props) => {
    return (
        <>
         <section className="bannerAreaN greyBackgroundN BannerDeatils position">
             <div className="detailsPageSection">
                <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_1440,h_600/VantageFit/NewWebsite/pageBanner__compressed.png" alt="corporate wellness" className="img-responsive"/>
             </div>
             <div className="BannerContent">
                 <div className="headingBannerM container customCampaignContainer text-left ">
                    <div className="row">
                        <div className=" col-lg-8 col-xs-12 col-md-7 col-sm-12"> 
                        <h1>Intuitive Admin Dashboard</h1>
                        <p className="colorwhite w7">
                        Get complete control over your workplace wellness initiatives with our intuitive admin dashboard.
                        </p>
                        <div className="mtb25">
                            <a href="/request-demo/" className="vfitwhitecta "> Schedule a Vantage Fit Demo </a>
                        </div>
                        </div>
                        <div className="col-lg-4  col-xs-12 col-md-5 col-sm-12 ">
                            <img alt="Step challenge" className ="mobileDisplay mobileimageW lozad" loading = "lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/v1608529698/VantageFit/NewWebsite/BannerImages_dashboardCompressed.png"/>
                        </div>
                    </div>
                </div>
             </div>

           
        </section>
        <section className="sectionSpacing greyBackgroundN pt-01 useCaseDesktop desktopView">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="mainHeadingN text-center">Feature Glance</div>
                    </div>
                    <div className=" features  HRdashboard innerSpace  row" id="featuresHR">
                        <div className=" col-md-8  col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-8 mx-auto hrfeaturesdashboard mid-activity">
                       
                            <div id="ContestHR">
                                <img  className="mx-auto max-w mob_image Image-Overlay active-img lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Contests_Challenges1.png" alt="Admin dashboard" />
                            </div>
                            <div id="Reports">
                                <img  className="mx-auto max-w mob_image Image-Overlay" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Insights.png" alt="Admin dashboard" />
                            </div>
                            {/* <div id="budgetManagement">
                                <img  className="mx-auto max-w mob_image Image-Overlay " loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Manage_Budget.png" alt="Admin dashboard" />
                            </div> */}
                            <div id="Broadcast">
                                <img  className="mx-auto max-w  mob_image Image-Overlay" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Health_Tips.png" alt="Admin dashboard" />
                            </div>
                        </div>
                         <div className="row_elementor col-md-8  col-md-offset-2  col-sm-offset-2 col-xs-12 col-sm-8 mx-auto innerSpace">
                            <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 hrfeaturesdashboard left-activity">
                                <div data-img="ContestHR" className="box_item active-sec">
                                    <div className="featuresimg">
                                        <div className="featuresSprite first-image activebox hidden-xs hidden-sm weeklystep"></div>
                                        <div className="featuresSprite second-image hidden-xs hidden-sm weeklystep"></div>
                                    </div>
                                    <div className="featurestext">
                                        <div className="trackertext moodmeter">Create Contests</div>
                                    </div>
                                    <div className="plusText featuresSprite activeBox"></div>
                                    <div className="plusDisplayText onlineBox">Host exciting wellness contests with the flexibility to modify them to spice things up.</div>
                                </div>
                                <div data-img="Reports" className="box_item ">
                                    <div className="featuresimg">
                                        <div className="featuresSprite first-image activebox hidden-xs hidden-sm realtimeinsights"></div>
                                        <div className="featuresSprite second-image hidden-xs hidden-sm realtimeinsights"></div>
                                    </div>
                                    <div className="featurestext">
                                        <div className="trackertext moodmeter">Real-time Analytics</div>
                                    </div>
                                    <div className="plusText featuresSprite activeBox"></div>
                                    <div className="plusDisplayText onlineBox">Get valuable insights into your wellness campaigns with advanced analytics and reports.</div>
                                </div>
                               
                            </div>
                            
                            <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 hrfeaturesdashboard right-activity">
                                
                                {/* <div data-img="budgetManagement" className="box_item">
                                    <div className="featuresimg">
                                        <div className="featuresSprite first-image activebox hidden-xs hidden-sm budgetmanage"></div>
                                        <div className="featuresSprite second-image hidden-xs hidden-sm budgetmanage"></div>
                                    </div>
                                    <div className="featurestext">
                                        <div className=" trackertext moodmeter ">Budget Management</div>
                                    </div>
                                    <div className="plusText featuresSprite activeBox"></div>
                                    <div className="plusDisplayText onlineBox">Allocate and manage the budget for your wellness contests as per your organizational requirements.</div>
                                </div> */}
                                <div data-img="Broadcast" className="box_item">
                                    <div className="featuresimg">
                                        <div className="featuresSprite first-image activebox hidden-xs hidden-sm healthcampaignS"></div>
                                        <div className="featuresSprite second-image hidden-xs hidden-sm healthcampaignS"></div>
                                    </div>
                                    <div className="featurestext">
                                        <div className=" trackertext moodmeter">Broadcast Health Tips</div>
                                    </div>
                                    <div className="plusText featuresSprite activeBox"></div>
                                    <div className="plusDisplayText onlineBox">Keep your employees up to date with the latest health and wellness trends through in-app notifications.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 cta_center">
                    <a className = "starttrailCTa">
                        <Lazyload><StartTrialModal /></Lazyload>
                    </a></div>
                </div>
            </div>
        </section>
        <section className = "sectionSpacing position usecasemobile mobileview  hrfeaturesmob" id="useCasez">
          <div className = "container customCampaignContainer">
            <div className = "row">
              <div className = "col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div className = "mainHeadingN ">
                 Feature Glance
                </div>
              </div>
            </div>
          </div>
           <div className="container customCampaignContainer " id = "useCasesz"> 
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter active">
                      <div className="useCasesBoxes  weeklystep active featuresSpriteM "  attr = "createcontest">Create Contests</div>
                    </div>
                  </div>
                <div className="col-lg-12 usecaseDesc active" id = "createcontest">
                    <div className="onlineBox  row column-change  d-flex align_items_center  mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                         Host exciting wellness contests with the flexibility to modify them to spice things up.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Contests_Challenges1.png" alt = "Admin dashboard" className = "max-w lozad" loading = "lazy" />
                        </div>
                    </div>
                </div>
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes realtimeinsightsS featuresSpriteM" attr = "realtime">Real-time Analytics</div>
                  </div>
                </div>
                <div className="col-lg-12 usecaseDesc" id = "realtime">
                    <div className="onlineBox  row column-change  d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                         Get valuable insights into your wellness campaigns with advanced analytics and reports.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Insights.png" alt = "Admin dashboard" className = "max-w lozad " loading = "lazy" />
                        </div>
                    </div>
                </div>
                {/* <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                      <div className="useCasesBoxes  budgetmanageS  featuresSpriteM"  attr = "budgetmanagement">Budget Management</div>
                    </div>
                  </div>
                <div className="col-lg-12 usecaseDesc" id = "budgetmanagement">
                    <div className="onlineBox  row column-change  d-flex align_items_center  mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                        Allocate and manage the budget for your wellness contests as per your organizational requirements.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Manage_Budget.png" alt = "Admin dashboard" className = "max-w lozad" loading = "lazy" />
                        </div>
                    </div>
                </div> */}
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter active">
                      <div className="useCasesBoxes  healthcampaignS  featuresSpriteM"  attr = "broadcasttips">Broadcast Health Tips</div>
                    </div>
                  </div>
                <div className="col-lg-12 usecaseDesc " id = "broadcasttips">
                    <div className="onlineBox  row column-change  d-flex align_items_center  mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                         Keep your employees up to date with the latest health and wellness trends through in-app notifications.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Health_Tips.png" alt = "Admin dashboard" className = "max-w lozad" loading = "lazy" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="sectionSpacing ">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="mainHeadingN text-center">Benefits</div>
                    </div>
                </div>
                <div className="row innerSpace  d-flex align-items-center column-change">
                        <div className = "col-lg-6 col-md-6 col-xs-12 col-sm-6 featuresNbenefits">
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Get detailed insights into your wellness campaigns and contests.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Create and run health contests with just a few simple clicks.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Manage your wellness budget and allocate it effectively among your employees.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Broadcast health tips to promote awareness among your workforce.
                            </div>
                        </div>
                        <div className = "col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <img src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/HR_Dashboard.png" alt="Admin dashboard" className="img-responsive lozad" loading = "lazy"/>
                        </div>
                </div>
            </div>
        </section>
         <section className="sectionSpacing featuresDetailsShape">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                        <div className="colorwhite mainHeadingN">Schedule a Vantage Fit Demo</div>
                        <p className="colorwhite">How Corporate Wellness Program can Help Your Organisation</p>
                        <div className="mtb25 cta_center margb"><a href="https://www.vantagefit.io/request-demo/" className="vfitwhitecta ">Schedule a Demo</a></div>
                    </div>
                </div>
            </div>
        </section>
        
        </>
    );
}

export default FitnessRewards;



